import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { useField, Label } from '../../../1stlog-ui/src/components/Field'
import Block from './Block'

const Wrapper = styled.div`
  display: flex;
`

const TariffWizard = (props) => {
  const { onlyExport, exportCountry, importCountry } = props

  const hscode = useField('exporttariffNumber')

  const [wasExportSelected, setWasExportSelected] = useState(false)
  const onExportSelected = (tariffNumber) => setWasExportSelected(tariffNumber)

  const resetWasExportSelected = () => setWasExportSelected(false)

  return (
    <Wrapper>
      <div style={{ flex: '1 0 0' }}>
        <Block
          type="export"
          onExportSelected={lodash.noop}
          exportCountry={exportCountry}
          importCountry={importCountry}
        />
      </div>
      {!onlyExport && (
        <div className="d-flex flex-column mx-3 mt-1" style={{ whiteSpace: 'nowrap' }}>
          <div>
            <Label>HS-Code</Label>
          </div>
          <div className="mt-1" style={{ fontSize: '1.1em' }}>
            {lodash.isString(hscode) ? hscode.slice(0, 6) : ''}
          </div>
        </div>
      )}
      {!onlyExport && (
        <div style={{ flex: '1 0 0' }}>
          <Block
            type="import"
            wasExportSelected={wasExportSelected}
            resetWasExportSelected={resetWasExportSelected}
            exportCountry={exportCountry}
            importCountry={importCountry}
          />
        </div>
      )}
    </Wrapper>
  )
}

export default TariffWizard
